import axios from 'axios';

//Setting base url for all API calls
const host = 'https://fleet.handsonsystems.com';

const request = (url, reduxState, options) => {
  return async () => {
    const config = {
      url: host + url,
      ...options,
      withCredentials: false,
      headers: {
        'content-type': 'application/json',
      },
    };

    try {
      const response = await axios(config);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export default request;
